import React from "react";
import "./styles.css";
import { styles } from "./styles";

const RedTag = props => {
  const { message } = props;
  return (
    <div style={styles.rtDiv}>
      <span style={styles.rtSpan}>{message}</span>
    </div>
  );
};

export default RedTag;
